import React from "react";
import {
    BehaviorImageCategories,
    BehaviorImageKey2CategoryName,
    BehaviorImageKeysWithTag,
    ImageKey2Src
} from "../../../assets/BehaviorImage";

type BehaviorImageSelectorProps = {
    selectedImageKey: string;
    SelectImage: (image_key: string) => void;
    onClickCloseButton: (e: React.MouseEvent) => void;
}
export const BehaviorImageSelector = (props: BehaviorImageSelectorProps) => {

    const [currentCategory, setCurrentCategory] = React.useState(BehaviorImageKey2CategoryName(props.selectedImageKey));

    const makeHandleClickImage = (image: string): React.MouseEventHandler<HTMLImageElement> => {
        return (e) => {
            e.stopPropagation();
            props.SelectImage(image);
        }
    }

    return (
        <div className="behavior-image-selector">
            <div className="category-list">
                {BehaviorImageCategories().map(c => <img
                    key={c.category_name}
                    src={c.category_src}
                    alt={c.category_name}
                    onClick={() => setCurrentCategory(c.category_name)}
                />)}
            </div>
            <div className="image-by-tag-list">
                {BehaviorImageKeysWithTag(currentCategory).map((tag_group) =>
                    <div className="tag-list" key={tag_group.tag}>
                        <div className="tag-name">{tag_group.tag}</div>
                        <div className="image-list">
                            {tag_group.image_keys.map((image_key, i) =>
                                <HoverUpImage key={image_key}
                                              index={i}
                                              src={ImageKey2Src(image_key)}
                                              alt={image_key}
                                              onClick={makeHandleClickImage(image_key)}
                                />
                            )}
                        </div>
                    </div>
                )}
            </div>

            <span className="close-button" onClick={props.onClickCloseButton}/>
        </div>
    );
}


type HoverUpImageProps = {
    index: number;
    src?: string;
    alt: string;
    onClick: React.MouseEventHandler<HTMLImageElement>;
}
const HoverUpImage = (props: HoverUpImageProps) => {

    const [popup_image, setShowPopupImage] = React.useState<boolean>(false);

    const handleMouseEnter: React.MouseEventHandler<HTMLImageElement> = (e) => {
        setShowPopupImage(true);
    }
    const handleMouseLeave: React.MouseEventHandler<HTMLImageElement> = (e) => {
        setShowPopupImage(false);
    }

    const popup_image_style: React.CSSProperties = {
        position: 'absolute',
        zIndex: 1,
        inset: props.index % 2 === 0 ? '0 auto auto 0' : 'auto auto 0 0',
        backgroundColor: '#ffffff',
        border: '2px solid #666666',
    }

    return (
        <div
            style={{position: 'relative'}}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <img className="behavior-image"
                 src={props.src}
                 alt={props.alt}
                 onClick={props.onClick}
            />
            {popup_image &&
              <img style={popup_image_style}
                   src={props.src} width="170" height="120"
                   alt={props.alt}
                   onClick={props.onClick}
              />}
        </div>
    )
}
